<template>
  <component :is="componentLoader"></component>
</template>

<script>
import store from '@/store/store';
export default {
  computed: {
    experience() {
      const loginType = localStorage.getItem('login_type');
      if (loginType == 'student') {
        const experiences = store.getters['authStudent/experiences'];
        return experiences.find((i) => i.id == this.$route.params.id);
      } else {
        return store.getters['authTeacher/experience'];
      }
    },
    componentLoader() {
      return () =>
        import('@/views/WorkExperiences/' + this.experience.vje.folder_name + '/Introduction.vue');
    },
  },
};
</script>
